export default __webpack_public_path__ + "static/blob4-1242548919f7ba826f371134389e453c.svg";